import axios from 'axios';

import c from '../helpers/constants';

export function getCustomerDetails(customerid: string, key: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.CUSTOMER_DETAILS}?customerid=${customerid}&key=${key}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}

export function getCustomerDeliveryAddresses(customerid: string) {
  return (
    axios({
      url: `${c.API_ENDPOINTS.CUSTOMER_DELIVERY_ADDRESSES}?customerid=${customerid}`,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
